export default __webpack_public_path__ + "static/media/question2.679bc205.png";